
import React from 'react';
import { Plus, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AdminActions } from './AdminActions';

interface TaskActionsProps {
  isAdmin: boolean;
  isMobile: boolean;
  onOpenDialog: () => void;
  onOpenLog: () => void;
  onExport: () => void;
  onImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearDatabase: () => void;
  onManageTemplates: () => void;
  onShowEmailLogs: () => void;
  onManageUsers: () => void;
  onWeeklyCalendar: () => void;
  onWeeklyReset?: () => Promise<{totalCoins: number, resetCount: number}>;
}

export const TaskActions = ({ 
  isAdmin, 
  isMobile, 
  onOpenDialog, 
  onOpenLog, 
  onExport, 
  onImport,
  onClearDatabase,
  onManageTemplates,
  onShowEmailLogs,
  onManageUsers,
  onWeeklyCalendar,
  onWeeklyReset
}: TaskActionsProps) => {
  return (
    <div className="fixed bottom-8 flex w-full px-8 z-10">
      {/* Left side with admin actions */}
      <div className="flex-1 flex justify-start">
        {isAdmin && (
          <div className={`${isMobile ? 'w-12' : ''} transition-all duration-300`}>
            <AdminActions 
              isMobile={isMobile} 
              onLogOpen={onOpenLog} 
              onExport={onExport} 
              onImport={onImport}
              onClearDatabase={onClearDatabase}
              onManageTemplates={onManageTemplates}
              onShowEmailLogs={onShowEmailLogs}
              onManageUsers={onManageUsers}
              onWeeklyCalendar={onWeeklyCalendar}
              onWeeklyReset={onWeeklyReset}
            />
          </div>
        )}
      </div>
      
      {/* Right side with calendar and add task buttons */}
      <div className="flex-1 flex justify-end gap-3 pr-6">
        <Button
          size="icon"
          className="h-16 w-16 rounded-full bg-secondary hover:bg-secondary/80 shadow-lg"
          onClick={onWeeklyCalendar}
          title="יומן שבועי"
        >
          <Calendar className="h-6 w-6" />
        </Button>
        <Button
          size="icon"
          className="h-16 w-16 rounded-full bg-primary hover:bg-primary/90 shadow-lg"
          onClick={onOpenDialog}
        >
          <Plus className="h-8 w-8" />
        </Button>
      </div>
    </div>
  );
};
